var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('module-card-last',{attrs:{"title":"Cool!"}},[_c('p',[_vm._v("You’ve earned an Underwear trophy! Keep going to collect more!")])])}
var staticRenderFns = []

export { render, staticRenderFns }